import { motion } from 'framer-motion'
import { Settings as SettingsIcon, Bell, Shield, Palette, Globe } from 'lucide-react'

const settingsSections = [
  {
    icon: Bell,
    title: '通知设置',
    description: '管理推送通知和邮件提醒',
  },
  {
    icon: Shield,
    title: '隐私安全',
    description: '账户安全和隐私设置',
  },
  {
    icon: Palette,
    title: '外观设置',
    description: '主题、字体和显示偏好',
  },
  {
    icon: Globe,
    title: '语言和区域',
    description: '语言、时区和区域格式',
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring' as const, stiffness: 300, damping: 24 },
  },
}

export default function Settings() {
  return (
    <div className="p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 300, damping: 24 }}
      >
        <div className="mb-8">
          <h1 className="text-2xl font-bold tracking-tight flex items-center gap-3">
            <SettingsIcon className="h-6 w-6" />
            设置
          </h1>
          <p className="mt-2 text-muted-foreground">
            管理你的账户和应用偏好
          </p>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 gap-5 sm:grid-cols-2"
        >
          {settingsSections.map((section) => {
            const Icon = section.icon
            return (
              <motion.div
                key={section.title}
                variants={itemVariants}
                whileHover={{ y: -4 }}
                className="group"
              >
                <div className="rounded-xl border border-border/50 bg-card/50 p-6 hover:border-border hover:bg-card transition-all duration-200 cursor-pointer">
                  <div className="flex items-start gap-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-gray-500 to-gray-600 shadow-lg">
                      <Icon className="h-5 w-5 text-white" />
                    </div>
                    <div>
                      <h3 className="font-semibold tracking-tight">{section.title}</h3>
                      <p className="mt-1 text-sm text-muted-foreground">
                        {section.description}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            )
          })}
        </motion.div>
      </motion.div>
    </div>
  )
}
